import React, { AnchorHTMLAttributes, forwardRef, ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { Colors } from 'types/Theme';
export type LinkSize = Extract<SizesType, 'xs' | 'sm' | 'md'>;
export type LinkVariant = keyof Colors['link'];
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Pass through style to allow styles overrides */
  style?: React.CSSProperties;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Size variant. If no size is provided, font-size inherited from surrounding text. */
  size?: LinkSize;
  /** Link variant. Can be one of 'default', 'strong', 'info' or 'inverse'. 'strong' by default */
  variant?: LinkVariant;
  /** An Icon to display on the right side of the Link for LTR languages. Inverted on RTL */
  iconEnd?: ReactNode;
}
const noSizeClass = "n1vdtv0u";
const textSizeClass: Record<LinkSize, string> = {
  xs: "x1vlkkc3",
  sm: "sls5a3a",
  md: "m1t4bv6e"
};
const LinkWrapper = /*#__PURE__*/styled('a')({
  name: "LinkWrapper",
  class: "l1o7m2hn",
  propsAsIs: false
});
export const TextWrapper = /*#__PURE__*/styled('span')({
  name: "TextWrapper",
  class: "tacy56m",
  propsAsIs: false
});
export const IconWrapper = /*#__PURE__*/styled('span')({
  name: "IconWrapper",
  class: "i1xh845j",
  propsAsIs: false
});
export const Link = forwardRef(({
  children,
  size,
  variant = 'default',
  dataId = '',
  iconEnd,
  className,
  ...anchorProps
}: Props & AnchorHTMLAttributes<HTMLAnchorElement>, ref: React.ForwardedRef<HTMLAnchorElement>) => <LinkWrapper data-id={dataId} className={cx(className, `--${variant}`)} ref={ref} {...anchorProps}>
      <TextWrapper className={cx(size ? textSizeClass[size] : noSizeClass)}>
        {children}
      </TextWrapper>
      {iconEnd && <IconWrapper>{iconEnd}</IconWrapper>}
    </LinkWrapper>);
Link.displayName = 'AtlasLink';

require("./Link.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Link.tsx");